<template>
    <div :class="parcelas ? '' : 'mt-3'" v-if="value && lista_impostos && ( value.retencoes.length || lista_impostos.length )">
        <div class="form-row">
            <div class="col col-12 col-md-6">
                <div class="btn-group" role="group" aria-label="Basic example" v-if="lista_impostos">
                    <button type="button" class="btn btn-sm" :class="imposto_selecionado(imposto) ? 'btn-secondary' : 'btn-outline-secondary'" 
                        v-for="(imposto, iix) in lista_impostos" :key="iix"
                        @click="incluir_imposto(imposto)" :disabled="!edicao">
                        {{ imposto.st_imposto }}
                    </button>
                </div>
            </div>

            <template v-if="aliquotas">

                <div class="col col-12 col-md-6" v-if="value">
                    <div class="input-group input-group-sm mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">Retenções</span>
                        </div>
                        <input type="text" class="form-control" disabled :value="total_impostos">
                        <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon1">
                                <i class="fa fa-percent" aria-hidden="true"></i>
                            </span>
                        </div>
                    </div>
                </div>

            </template>

            <template v-else-if="!parcelas">

                <div class="col col-12 col-md-3" v-if="value">
                    <div class="input-group input-group-sm mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">Retenções</span>
                        </div>
                        <input type="text" class="form-control" disabled :value="total_impostos">
                    </div>
                </div>

                <div class="col col-12 col-md-3" v-if="value">
                    <div class="input-group input-group-sm mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">Líquido</span>
                        </div>
                        <input type="text" class="form-control" disabled :value="liquido">
                    </div>
                </div>

            </template>

        </div>

        <div class="form-row" v-if="value && !recalculando">
            <template v-for="(retencao, isx) in lista_retencoes">
                <div class="col col-12 col-md-3" :key="isx" v-if="retencao.fl_ativo">
                    <az-input
                        icon="prepend"
                        sizing="sm"
                        type="money"
                        :edicao="edicao"
                        v-if="aliquotas"
                        v-model="retencao.dc_aliquota">
                        <template v-slot:prepend>
                            <span class="input-group-text" id="basic-addon2">
                                {{ retencao.imposto.st_imposto }}
                            </span>
                        </template>
                        <template v-slot:buttonposb>
                            <div class="input-group-append">
                                <span class="input-group-text" id="basic-addon2">
                                    <i class="fa fa-percent"></i>
                                </span>
                            </div>
                        </template>
                    </az-input>

                    <az-input
                        v-else
                        icon="prepend"
                        sizing="sm"
                        type="money"
                        :edicao="edicao"
                        v-model="retencao.dc_valor">
                        <template v-slot:prepend>
                            <span class="input-group-text" id="basic-addon2">
                                {{ retencao.imposto.st_imposto }}
                            </span>
                        </template>
                        <template v-slot:buttonposb>
                            <div class="input-group-append">
                                <span class="input-group-text" id="basic-addon2">
                                    <i class="fas fa-dollar-sign"></i>
                                </span>
                            </div>
                        </template>
                    </az-input>
                </div>
            </template>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data () { 
        return { 
            dados: null, 
            lista_impostos: null,
            recalculando: false, 
        }
    }, 

    computed: { 
        valor_total: function () { 
            return this.lista_retencoes.filter(item => item.fl_ativo)
                .reduce((total, carry) => { 
                    return total + ( this.aliquotas ? carry.dc_aliquota : carry.dc_valor );
                }, 0);
        },
        total_impostos: function () { 
            return this.$util.formatMoeda(this.valor_total);
        },

        liquido: function () { 
            return this.$util.formatMoeda(
                ( this.value.dc_valor ? this.value.dc_valor : 0 ) 
                - ( this.value.dc_valor_uso_adiantamento ? this.value.dc_valor_uso_adiantamento : 0 ) 
                - ( this.value.dc_descontos ? this.value.dc_descontos : 0 ) 
                + ( this.value.dc_multa_juros ? this.value.dc_multa_juros : 0 ) 
                - this.valor_total
            );
        },

        selecionados: function () { 
            if ( !this.lista_impostos )
                return [];

            return this.lista_impostos.filter(item => item.selecionado);
        },

        lista_retencoes: function () { 
            if ( !this.value || !this.value.retencoes ) 
                return [];

            return this.value.retencoes; // .filter(item => item.fl_ativo);
        }

    },

    components: {
        AzInput,
    },

    props: [
        'value',
        'impostos', 
        'aliquotas', 
        'edicao',
        'parcelas',
    ],

    methods: { 
        imposto_selecionado (imposto) { 
            if ( !this.value )
                return false; 

            return this.lista_retencoes.find(item => item.id_imposto == imposto.id_imposto && item.fl_ativo) ? true : false;
        },

        incluir_imposto (imposto) { 

            let retencao = this.value.retencoes.find(item => item.id_imposto == imposto.id_imposto);

            if ( retencao ) { 
                retencao.fl_ativo = !retencao.fl_ativo;
            } else { 
                if ( !this.aliquotas ) { 
                    this.value.retencoes.push({ 
                        id_imposto: imposto.id_imposto,
                        dc_valor: Math.round(this.value.dc_valor * imposto.dc_aliquota) / 100,
                        dc_aliquota: imposto.dc_aliquota, 
                        imposto: imposto, 
                        fl_ativo: true, 
                    });
                } else { 
                    this.value.retencoes.push({ 
                        id_imposto: imposto.id_imposto,
                        dc_aliquota: imposto.dc_aliquota, 
                        imposto: imposto, 
                        fl_ativo: true, 
                    });
                }
            }
            
        },

        recalcular() { 
            this.recalculando = true;

            this.$nextTick(() => { 
                this.value.retencoes.forEach(retencao => {
                    retencao.dc_valor = Math.round(this.value.dc_valor * retencao.imposto.dc_aliquota) / 100;
                });

                this.recalculando = false;
            })
        },

        incluir_do_fornecedor (fornecedor) { 
            if ( !fornecedor ) {
                this.value.retencoes.forEach(item => { 
                    item.fl_ativo = false;
                });
            } else if ( !this.lista_retencoes.length ) { 
                fornecedor.retencoes.forEach(item => { 
                    item.st_imposto = item.imposto.st_imposto;
                    this.incluir_imposto(item);
                });
            }
        },

        refresh_lista(impostos) { 
            this.lista_impostos = _.cloneDeep(impostos);    
        }
    },

    mounted() { 
        this.lista_impostos = _.cloneDeep(this.impostos);
    }
}
</script>